import { Article } from "features/article/types/article";
import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import batchOperations from "services/firebase/batchOperations";

import { AppThunk } from "services/redux/rootReducer";

const removeManyArticles =
    (ids: string[]): AppThunk =>
    async (dispatch) => {
        const articlesRemoved: Article[] = [];

        await batchOperations(async (batch, db, batchedIds) => {
            await Promise.all(
                batchedIds.map(async (id) => {
                    const idRef = db.collection("articles").doc(id);
                    const articleRemoved = (
                        await idRef.get()
                    ).data() as Article;
                    articlesRemoved.push(articleRemoved);
                    batch.delete(idRef);
                })
            );
        }, ids);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Removed article(s) with names(s) ${articlesRemoved
                        .map((article) => article.properties.name?.en)
                        .join(", ")}`,
                },
            })
        );

        return;
    };

export default removeManyArticles;
